export default __webpack_public_path__ + "static/media/FSKoopman-Bold.c7ce308d.woff2";